import React, { useEffect } from 'react';
import { useFormikContext } from 'formik';
import AccordionWrapper from 'App/components/AccordionWrapper/AccordionWrapper';
import HeaderContent from '../HeaderContent';
import ExcludeToggleFilter from './ExcludeToggleFilter';
import { CheckboxField } from 'Shared/form/CheckboxField';
import { CheckboxMultiField } from 'Shared/form/CheckboxMultiField';
import { setWorkQueueFilterGenerator } from '../../workQueue.utils';

const BranchMultiSelectFilter = () => {
    const {
        values: { filterParams, allBranchesList },
        setFieldValue,
    } = useFormikContext();
    const { branches, allBranches, excludeBranches } = filterParams;
    const setWorkQueueFilter = setWorkQueueFilterGenerator(setFieldValue);

    const isExcludeDisabled = allBranches || !branches.length || branches.length === (allBranchesList || []).length;

    useEffect(() => {
        if (isExcludeDisabled && excludeBranches) {
            setFieldValue('filterParams.excludeBranches', false);
        }
    }, [isExcludeDisabled, excludeBranches, setFieldValue]);

    return (
        <AccordionWrapper
            title="Branch"
            stateKey="workQueueBranchFilter-toggle"
            HeaderContent={HeaderContent}
            headerClassName="accordion-header-h4-title"
        >
            <div className="multi-select-spacing-filter">
                <ExcludeToggleFilter
                    fieldName="filterParams.excludeBranches"
                    disabled={isExcludeDisabled}
                    onChange={(checked) => setWorkQueueFilter(filterParams, 'excludeBranches', checked, true)}
                />
                <CheckboxField
                    fieldName="filterParams.allBranches"
                    className="spacing-leading-checkbox"
                    label="All Branches"
                    onChange={(e) =>
                        setWorkQueueFilter(
                            {
                                ...filterParams,
                                branches: e.target.checked ? [] : branches,
                                excludeBranches: e.target.checked ? false : excludeBranches,
                            },
                            'allBranches',
                            e.target.checked,
                            true
                        )
                    }
                />
                {!allBranches && (
                    <CheckboxMultiField
                        fieldName="filterParams.branches"
                        className="spacing-multi-checkboxes"
                        value={branches}
                        options={allBranchesList}
                        onChange={(value) => setWorkQueueFilter(filterParams, 'branches', value, true)}
                    />
                )}
            </div>
        </AccordionWrapper>
    );
};

export default BranchMultiSelectFilter;
